import React from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import ScrollToTop from "../Shared/ScrollToTop";

const MainLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
    <ScrollToTop />
    <ToastContainer position="top-right" theme="light" hideProgressBar autoClose={3000} />
  </>
);

export default MainLayout;
